import Cookies from 'js-cookie'

let cachedClientId = null

function fromCookie() {
    const raw = Cookies.get('_ga')
    if (!raw) {
        return null
    }
    const parts = raw.split('.')
    return parts.length >= 4 ? parts.slice(-2).join('.') : null
}

export function resolveClientId(config) {
    cachedClientId = fromCookie()

    const measurementId = config.ga4_measurement_id

    if (
        config.script_type === 'ga' &&
        typeof measurementId === 'string' &&
        /^G-/.test(measurementId) &&
        typeof window.gtagForRocketEffect === 'function'
    ) {
        try {
            window.gtagForRocketEffect('get', measurementId, 'client_id', clientId => {
                if (clientId) {
                    cachedClientId = clientId
                }
            })
        } catch (e) {
            // gtag.js can throw for a misconfigured/unrecognized measurement ID;
            // the cookie-derived client id above is still available as a fallback.
        }
    }
}

export function getCachedClientId() {
    return cachedClientId
}
